import React from 'react';
import styled from "styled-components";
import {FilterDispatcherContext} from "@providers/filters";
import ConvertPixelToRem from "@helpers/convert.rem";
import Icon from "@atoms/icon";
import CloseIcon from '@icons/close.svg';
import {useWindowSize} from "../../../helpers/windows.size";

export default function ModalFiltersHeader({selectedFiltersCount, setModalFiltersShow}) {
    const windowSize = useWindowSize();
    const filterDispatcher = React.useContext(FilterDispatcherContext);

    const handleReset = async () => {
        const modalFiltersContainer = document.querySelector('.modal-filters');
        modalFiltersContainer.querySelectorAll('.selection').forEach((element, key) => {
            element.classList.remove('selected');
        });

        await filterDispatcher({
            type: 'RESET_FILTERS',
            payload: (window.innerWidth < 768 ? 'mobile' : 'desktop')
        });
    };

    let showClear = false;

    if ((windowSize > 991 && selectedFiltersCount.desktop > 0) || (windowSize < 992 && selectedFiltersCount.mobile > 1)) {
        showClear = true;
    }

    return (
        <FiltersHeader className="d-flex align-items-center justify-content-between">
            <ModalClose className="line-height-0" onClick={() => setModalFiltersShow(false)}>
                <Icon width="16">
                    <CloseIcon/>
                </Icon>
            </ModalClose>
            <span className="header-title">فیلترها</span>

            {
                (showClear) ?
                    <ClearFilters className="bg-danger text-danger-text rounded-pill" onClick={() => handleReset()}>حذف فیلترها</ClearFilters>
                    : ''
            }
        </FiltersHeader>
    )
}

// ******
// style
// ******
const FiltersHeader = styled.div`
    position: relative;
    height: 56px;
    padding: 0 24px;
    border-bottom: 1px solid ${props => props.theme.gray200};
     
    .header-title {
        position: absolute;
        left: 50%;
        top: 50%;
        font-size: ${ConvertPixelToRem(18)};
        font-weight: bold;
        line-height: 1.67;
        text-align: center;
        color: ${props => props.theme.black};
        transform: translate(-50%,-50%);
    }
`;

const ModalClose = styled.div`
    cursor: pointer;
`;

const ClearFilters = styled.button`
    position: relative;
    font-size: ${ConvertPixelToRem(12)};
    font-weight: 500;
    line-height: 1.58;
    text-align: center;
    color: ${props => props.theme.black};
    border: 0;
    padding: 4px 12px;
`;